import React, { memo, useState, useEffect } from 'react';

import { Icon, LoadingSpin64 } from '@/components';
import { LiveVideosDefault, LiveVideosTypes } from '@/features/livestream/shared';
import { TFunction } from 'next-i18next';
import TitlePartial from '@/components/ui/Title';
import { useFetchLiveVideosQuery } from '../../api';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import { VideoLoop } from '@/components/loop/VideoLoop';

type ListPartialProps = {
  t: TFunction;
};

const ListPartial = ({ t }: ListPartialProps) => {
  const [liveVideosCursor, setLiveVideosCursor] = useState<LiveVideosTypes>(LiveVideosDefault);
  const { refetch, isLoading } = useFetchLiveVideosQuery(
    {
      limit: 4,
      offset: 0,
    },
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (data) => {
        toast.error(data.message);
      },
      onSuccess: ({ data, total_records: totalRecords }) => {
        const edges = Array.isArray(data) ? data : [];
        setLiveVideosCursor({ edges, count: +totalRecords });
      },
    }
  );
  useEffect(() => {
    refetch();
  }, []);

  return (
    <div>
      <TitlePartial name={t('detail.list-live-title')} className="_title-live-detail" />
      <div className="tw-flex tw-flex-col tw-mt-10">
        {isLoading ? (
          <div className="tw-h-10 tw-flex tw-justify-center tw-items-center tw-text-primary-main">
            <Icon icon={<LoadingSpin64 />} />
          </div>
        ) : (
          <motion.div
            initial="mainInitial"
            animate="mainAnimate"
            exit="mainExit"
            variants={{
              mainInitial: {
                opacity: 0,
              },
              mainAnimate: {
                opacity: 1,
                transition: {
                  duration: 0.4,
                },
              },
              mainExit: {
                opacity: 0,
              },
            }}
          >
            {!!liveVideosCursor.edges && (
              <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2 md:tw-gap-4">
                {liveVideosCursor.edges.map((v) => (
                  <VideoLoop key={v.id} v={v} t={t} />
                ))}
              </div>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default memo(ListPartial);
